import React from 'react';
import styled from 'styled-components';
import Button from '../common/Button';

const AboutSection = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 80px 0;
`;

const AboutContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const AboutContent = styled.div`
  flex: 2;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    text-align: center;
  }
`;

const AboutTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 20px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const AboutText = styled.p`
  margin-bottom: 20px;
  color: ${props => props.theme.colors.grey[600]};
  font-size: ${props => props.theme.fontSizes.regular};
  line-height: 1.8;
`;

const FounderProfile = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  padding: 30px;
  border-radius: 8px;
  box-shadow: ${props => props.theme.shadows.regular};
`;

const FounderImage = styled.div`
  margin-bottom: 20px;
  
  img {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

const FounderInfo = styled.div`
  text-align: center;
  
  h3 {
    margin-bottom: 5px;
    color: ${props => props.theme.colors.secondaryColor};
  }
  
  p {
    margin-bottom: 5px;
    color: ${props => props.theme.colors.grey[600]};
  }
`;

const AboutPreview = () => {
  return (
    <AboutSection>
      <div className="container">
        <AboutContainer>
          <AboutContent>
            <AboutTitle>About KALS Academy</AboutTitle>
            <AboutText>
              Founded by C. Kalyanasundaram M.E. (Structural), M.I.E., C.Eng., Former Superintending Engineer - PWD, 
              KALS Academy is committed to providing quality education in the field of structural engineering.
            </AboutText>
            <AboutText>
              Our academy combines theoretical knowledge with practical applications to prepare students 
              for successful careers in structural design and engineering.
            </AboutText>
            <Button to="/about" variant="secondary">Read More About Us</Button>
          </AboutContent>
          
          <FounderProfile>
            <FounderImage>
              <img src="/placeholder/300/300" alt="C. Kalyanasundaram" />
            </FounderImage>
            <FounderInfo>
              <h3>C. Kalyanasundaram</h3>
              <p>M.E. (Structural), M.I.E., C.Eng.</p>
              <p>Former Superintending Engineer - PWD</p>
              <p>Founder & Director</p>
            </FounderInfo>
          </FounderProfile>
        </AboutContainer>
      </div>
    </AboutSection>
  );
};

export default AboutPreview;
